/* eslint-disable */
var proc = {
  env: { NODE_ENV: 'development' },
  browser: true,
  version: '',
  versions: {},
  platform: 'browser',
  nextTick: function(fn) { setTimeout(fn, 0); }
};

if (typeof window !== 'undefined') {
  window.process = window.process || proc;
  window.process.env = window.process.env || proc.env;
  if (!window.process.env.NODE_ENV) {
    window.process.env.NODE_ENV = 'development';
  }
  window.global = window;
}
if (typeof self !== 'undefined') {
  self.process = self.process || (typeof window !== 'undefined' ? window.process : proc);
  self.global = self;
}
